module.exports = __webpack_public_path__ + "static/media/logo_aero_argentinas.29c6555d.png";